<template>
  <model-table
    :title="$_.startCase(currentCircuit.rewardsCurrencyName)"
    :collection="membershipType.membershipPoints"
    :submodel="true"
    :columns="[
      { field: 'name', align: 'left', sortable: true },
      { name: 'pointsType', field: membershipPoint => $_.startCase(membershipPoint.pointsType), component: 'chip' },
      { field: 'pointsRate', component: 'chip' },
      { name: 'expires', align: 'left', label: 'Expire After', field: row => { return row.expire ? $_.startCase(row.expires + ' ' + row.expiryTerm) : 'Never' } },
      { field: 'formattedConditions', align: 'left', label: 'Conditions', component: 'chips', limitValues: 3 },
      { field: 'enable', align: 'left', label: 'Enabled', component: 'checkmark-or-negative' },
      { field: 'actions', label: 'Actions' }
    ]"
    :add-label="$_.startCase(currentCircuit.rewardsCurrencyName)"
  >
    <membership-point-form
      ref="membershipPointForm"
      :submodel="true"
      :membership-type="membershipType"
    />
  </model-table>
</template>

<script>

import MembershipType from 'src/models/membership-type/MembershipType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipPointForm from 'src/modules/admin/membership-type/MembershipPointForm'

export default {
  name: 'MembershipPointTable',
  components: {
    ModelTable,
    MembershipPointForm
  },
  configuration: ['currentCircuit'],
  props: {
    membershipType: {
      type: MembershipType,
      required: true
    }
  }
}
</script>
